// extracted by mini-css-extract-plugin
export default {"answerGroup":"index_answerGroup__-+d1w","half":"index_half__b9YD9","full":"index_full__olTmO","listWrap":"index_listWrap__ngVHF"};